import createActionType from "../../utils/createActionType";

export const MODULE = "planner/schedule-state-filter";

export const SET_SCHEDULE_STATE = createActionType(MODULE, "setScheduleState");

export const RESET = createActionType(MODULE, "reset");
